// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__on7Fh","left":"StickyBox_left__2D62F","right":"StickyBox_right__3BbM8"};